import React, { Component } from 'react'
import { ContainerHistoric, Title, Footer } from './historic.style'
import List from './componentes/list/list.component'
import Table from './componentes/table/table.component'

class Historic extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { extract, monthDescription, notes, invoiceExists } = this.props
		const containerStyle = invoiceExists ? {} : { padding: '0' }
		return (
			<ContainerHistoric style={containerStyle}>
				{invoiceExists ? (
					<React.Fragment>
						<Title className="-mobile">Transações</Title>
						<Title className="-desktop">
							{monthDescription}
							<em>{notes}</em>
						</Title>
						<List extract={extract} />
						<Table extract={extract} />
					</React.Fragment>
				) : (
						<React.Fragment></React.Fragment>
					)}
			</ContainerHistoric>
		)
	}
}

export default Historic
